<template>
  <simple-modal v-model="showModal" title="add image" @onClose="closeModal" size="responsive" has-footer :has-button-close="!loadingStashboardMedia">
    <template slot="body">
      <div v-for="error in errors" class="error-banner text-white bg-red mb-5">
        {{error}}
      </div>
      <div class="add-image-modal max-w-xs sm:max-w-xl m-auto flex justify-center items-center">

      <template v-if="loadingStashboardMedia">
        <sb-loading-icon />
      </template>

      <div v-else class="border border-solid rounded-xl mx-1 sm:mx-3 overflow-hidden">
        <div class="add-image-container flex flex-row items-center justify-center relative" v-bind:class="{ 'empty': !anySelected }">

          <div class="content-wrapper w-full h-full">
            <div class="grid grid-cols-3 h-full">
              <div class="col-span-2 flex flex-column items-begin border-r-1 border-0 border-solid" v-if="anySelected">
                <carousel-actions v-if="anySelected"
                                  class="w-full"showAddVideoModal
                                  @remove-slide="removePosition"
                                  :slides="mySelectedOwnerMedia"/>
              </div>
              <div class="flex items-center relative" v-bind:class="{ 'col-span-1': anySelected, 'col-span-3': !anySelected }">
                <div class="flex absolute top-2 right-2" v-show="anySelected">
                  <div class="swiper-pagination-edit flex items-center text-lg text-lime-700"/>
                </div>
                <button
                    class="sb-button flex flex-col items-center mx-auto small-size p-0 upload-button"
                    @click='clickedUpload'>
                  <fai :icon="['fal', 'image']" size="2x"/>
                  upload
                </button>
              </div>
            </div>
          </div>
        </div>
        <section
            class='img-section border-0 border-t border-solid flex flex-row flex-wrap overflow-overlay box-content'>
          <div v-for="media in mungedStashboardMedia"
               :style="`background-image: url(${media.result_url})`"
               class="sb-thumbnail box-border bg-cover bg-center cursor-pointer bg-no-repeat relative"
               :class="{ 'border-3 border-solid': media.local_position}"
               @click="clickedMedia(media)">
            <div
                class="text-lime-700 label-counter text-xs flex items-center justify-center absolute rounded-full leading-normal right-0 top-0"
                v-if="media.local_position">
              {{ media.local_position }}
            </div>
          </div>
        </section>
      </div>

      <input
          accept="image/png,image/gif,image/jpeg"
          class="hidden"
          ref="file-dialog"
          multiple
          type="file"
          data-cy="photo-upload-input"
          @input="fileChanged"/>
      </div>
    </template>
    <template slot="footer">
      <div class="flex justify-center">
      <button class="sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12"
              :disabled="disableSubmit"
              :class="{'sb-disabled': disableSubmit}"
              @click="submit">{{ btnText }}
      </button>
      </div>
    </template>
  </simple-modal>
</template>

<script>
import {LoadingIcon} from "@springbig/sb-components";
import SimpleModal from "simple-modal-vue";
import CarouselActions from "./carousel-actions.vue";
import {mapGetters} from "vuex"
import "./very-simple-modal.css";

export default {
  name: "EditStashboardMediaModal",
  components: {
    SimpleModal,
    LoadingIcon,
    CarouselActions
  },
  props: {
    stashboardMedia: Array,
    disableBtn: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      mungedStashboardMedia: [],
      originalStashboardMedia: [],
      errors: [],

      showModal: true
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.rejectModal)
  },
  created() {
    window.addEventListener('beforeunload', this.rejectModal)
    this.mungedStashboardMedia = _.cloneDeep(this.stashboardMedia)
    this.originalStashboardMedia = [
      ...this.stashboardMedia.filter((sm) =>
        this.isOwner(sm)
      )
    ]

    _(this.mungedStashboardMedia)
      .filter((sm) => this.isOwner(sm))
      .sortBy((sm) => sm.position)
      .value()
      .forEach((sm, idx) => {
        sm.local_position = idx + 1
      })
  },
  methods: {
    submit() {
      const selected = this.selectedStashboardMedia()
      const cmd = {
        stashboardMedia: _.map(selected, (sm) => {
          // the store sorts by [comm type, position, created_at]
          sm.position = sm.local_position
          return sm
        }),
        communication_type: this.stashboardCommunicationType,
        media_type: 'image'
      };
      this.$store.dispatch('BULK_SAVE_STASHBOARD_MEDIA_FOR_ONE_TYPE', cmd).then((stashboardMedia) => {
        this.closeModal()
      })
    },
    closeModal() {
      this.$emit('update:showModal', false)
    },
    selectedOwnerMedia() {
      return _(this.mungedStashboardMedia)
        .filter((sm) => this.isOwner(sm) && sm.local_position)
        .sortBy((sm) => sm.local_position)
        .value()
    },
    clickedUpload() {
      if (this.stopBecauseOfLimit()) {
        return
      }
      this.fileDialog.click();
    },
    fileChanged() {
      this.hideError()
      const file_count = this.fileDialog?.files.length || 0
      const mediaCount = this.maxPosition() + file_count
      if (this.stopBecauseOfLimit(mediaCount)) {
        return
      }
      if (file_count > 0) {
        const files = [...this.fileDialog.files]
        if (files.some((file) => file.size / 1024 / 1024 > 10)) {
          this.showError('file must be less than 10 mb')
          return
        }
        files.forEach((file) => {
          this.$store.dispatch('ADD_STASHBOARD_MEDIA', {
            file: file,
            communication_type: this.stashboardCommunicationType,
            media_type: 'image'
          }).then((stashboard_media) => {
            if (stashboard_media.errors) {
              this.showError(stashboard_media.errors)
            }
            else
            {
              this.addPosition(stashboard_media)
              this.mungedStashboardMedia.unshift(stashboard_media)
              this.mungedStashboardMedia = _.take(this.mungedStashboardMedia, 21)
            }
          })
        })
        this.fileDialog.value = '';
      }
    },
    isOwner(sm) {
      return sm.owner_id == this.ownerId &&
        sm.owner_type == this.ownerType &&
        sm.communication_type == this.stashboardCommunicationType
    },
    selectedStashboardMedia() {
      return _.filter(this.mungedStashboardMedia, (sm) => sm.local_position)
    },
    clickedMedia(stashboardMedia) {
      if (stashboardMedia.local_position) {
        this.removePosition(stashboardMedia)
        this.hideError()
      }
      else if (!this.stopBecauseOfLimit()) {
        this.addPosition(stashboardMedia)
        if (!this.isOwner(stashboardMedia)) {
          this.$store.dispatch('ADD_STASHBOARD_MEDIA', {
            copy_stashboard_media: stashboardMedia,
            communication_type: this.stashboardCommunicationType,
            media_type: 'image'
          }).then((serverStashboardMedia) => {
            serverStashboardMedia.local_position = stashboardMedia.local_position
            const idx = _.indexOf(this.mungedStashboardMedia, stashboardMedia)
            this.mungedStashboardMedia.splice(idx, 1, serverStashboardMedia)
          })
        }
      }
    },
    maxPosition() {
      return _(this.mungedStashboardMedia).map((sb) => sb.local_position).max() || 0
    },
    nextPosition() {
      return this.maxPosition() + 1
    },
    stopBecauseOfLimit(mediaCount = this.nextPosition()) {
      if (mediaCount > this.maxImages) {
        this.showError(`you can only add up to ${this.maxImages} images`)
        return true
      }
      return false
    },
    addPosition(stashboardMedia) {
      if (!this.stashboardMultipleEnabled) {
        this.selectedOwnerMedia().forEach((sm) => {
          sm.local_position = null
        })
      }
      stashboardMedia.local_position = this.nextPosition()
      this.makeViewReRenderGrid()
    },
    removePosition(stashboardMedia) {
      stashboardMedia.local_position = null
      this.selectedOwnerMedia().forEach((sm, idx) => {
        sm.local_position = idx + 1
      })
      this.makeViewReRenderGrid()
    },
    makeViewReRenderGrid() {
      // grr
      this.mungedStashboardMedia = [...this.mungedStashboardMedia]
    },
    showError(errorText) {
      this.errors = [errorText]
    },
    hideError: function() {
      this.errors = []
    },
  },
  computed: {
    fileDialog() {
      return this.$refs['file-dialog']
    },
    btnText() {
      return this.selectedStashboardMedia().length < 2 ? 'add image' : 'add images'
    },
    anySelected() {
      return this.selectedStashboardMedia().length > 0
    },
    mySelectedOwnerMedia() {
      return this.selectedOwnerMedia()
    },
    disableSubmit() {
      return this.loadingStashboardMedia ||
        (!this.anySelected && !this.stashboardMedia.filter((sm) => this.isOwner(sm)).length > 0) // make sure there are selections, unless they're trying to deselect everything
    },
    ...mapGetters([
      'loadingStashboardMedia',
      'maxImages',
      'stashboardCommunicationType',
      'stashboardMultipleEnabled',
      'ownerStashboardMedia'
    ]),
    ...mapGetters({
      ownerId: "stashboardOwnerId",
      ownerType: "stashboardOwnerType",
      owner: "stashboardOwner"
    })
  }
}
</script>

<style scoped>
.upload-button {
  border-radius: 16px;
  padding: 10px 30px;
}
.img-section {
  max-height: 236px;
}
@media screen and (max-width: 640px) {
  .img-section {
    max-height: 233px;
  }
}

.add-image-container.empty {
  height: 400px;
}

.sb-thumbnail {
  width: 78.5px;
  height: 78.5px;
}
@media screen and (max-width: 640px) {
  .sb-thumbnail {
    width: 77.5px;
    height: 77.5px;
  }
}
.sb-thumbnail .label-counter {
  width: 20px;
  height: 20px;
}

.sb-button.small-size {
  width: 110px;
}

.swiper-button-disabled {
  display: block !important;
}

</style>
